"use client";

import { ExpertAgentWidget } from "@/components/expert-agent-widget";
import { IntercomWidget } from "@/components/intercom-widget";

/**
 * Which support surface an expert gets. One decision, both mount points.
 *
 * The choice lives here rather than at the two call sites in the `/me` layout
 * for the reason two call sites always eventually diverge: whichever one is
 * forgotten leaks Intercom to somebody the rollout moved off it.
 *
 * Not rendering `IntercomWidget` is what turns Intercom off. Its unmount
 * cleanup calls `shutdown()` -- added by #6836 for exactly this reason, since
 * Intercom's injected launcher otherwise survives client-side navigation -- so
 * the gate needs no boot flag inside the widget and `intercom-widget.tsx` is
 * left alone.
 */
export function SupportSurface({
  shouldUseExpertAgent,
  sharesTheCorner = false,
}: {
  shouldUseExpertAgent: boolean;
  /** Passed to whichever arm renders, so both step aside by the same amount. */
  sharesTheCorner?: boolean;
}) {
  return shouldUseExpertAgent ? (
    <ExpertAgentWidget sharesTheCorner={sharesTheCorner} />
  ) : (
    <IntercomWidget sharesTheCorner={sharesTheCorner} />
  );
}
